<div *ngIf="offeneNutzer.length > 0">
  <app-user-table [title]="'Anfragen'" [list]=offeneNutzer [filterKey]="'ANFRAGEN'"></app-user-table>
  <hr>
</div>
<app-user-table [title]="'Benutzer'" [list]=nutzer [filterKey]="'NUTZER'"></app-user-table>
